import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b50c249e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50c249e')) {
      api.createRecord('b50c249e', component.options)
    } else {
      api.reload('b50c249e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b50c249e&", function () {
      api.rerender('b50c249e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23m9Z44veXyd5/JS/offershelp.vue"
export default component.exports